import React, { useEffect, useState, useRef } from 'react';

import { useIntl } from 'react-intl';
import ReactDOMServer from 'react-dom/server';
import cssContent from 'css-loader!./../../../helpers/popups/popups.css';
import AceEditor from 'react-ace';
import boardTypes from '@modules/boards/features/constants';
import { getCosmosItem } from '../../../cosmos';
import { getLocale } from '../../../config/locale';
import * as pjson from '../../../../package.json';
import { loadExt } from '../../../helpers/LoadAndKillerScripts';
import { createElementFromHTML } from '../../../helpers/CoolFunctions';
import * as profiles from '../../../helpers/profiles';
import Drone from '../../../helpers/Drone';
import events from '../../../helpers/events';
import WorkspaceClient from '../../../helpers/events/collaborationSession/workSpaceClient';
import Tooltip from '../../../components/Tooltip';
import BottomNavDrone from '../../../components/BottomNavDrone';
import CodePanel from './codePanel';
import FooterPanel from './footerPanel';
import ToolsPanel from './toolsPanel';
import { useUpdateBlockly } from '../features/hooks';
import { useSelector, useDispatch } from 'react-redux';
import { startLoading, finishLoading } from '@modules/blockly/features/blocklySlice';
import MLPanel from './MLPanel'
import { setMLActive } from '@modules/blockly/features/blocklySlice';


// TODO: Refactor this to not being hardcoded on darkthemeToggle
const themeKey = getCosmosItem('theme');
const themeLang = getLocale().locale;

function BlocklyComponent({
  tabInfo,
  userData,
  socket,
  socketAgent,
  socketAgentType,
  buildingFunction,
  buildAllowed,
  portChangeAllowed,
  teamList,
  setWorkspace,
  noCodePanel,
  isCreabots,
  isFreeProject,
  iaModelJson,
  iaModelBin,
}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const bloquesState = useSelector((state) => state.bloquesReducer);
  const [darkthemeToggle, setDarkthemeToggle] = useState(!(themeKey === 'theme-aula' || themeKey === 'theme-labs'));
  const [toolboxToggle, setToolboxToggle] = useState(false);
  const [codeToggle, setCodeToggle] = useState(false);
  const [codeGenerated, setCodeGenerated] = useState('');
  const [blocklyProject, setBlocklyProject] = useState({});
  const [actualWidth, setActualWidth] = useState(window.innerWidth);
  const [demoWorkspace, setDemoWorkspace] = useState(null);
  const [droneSimulationToggle, setDroneSimulationToggle] = useState(false);
  const [bloques, setBloques] = useState(false);
  const [drone, setDrone] = useState(new Drone(tabInfo.board.profile));
  const [loading, setLoading] = useState(true);
  useUpdateBlockly(blocklyProject);

  const boardType = tabInfo.boardType;
  const blocklyOptions = {
    media: `${process.env.IS_ELECTRON ? '.' : ''}/images/media/`,
    comments: false,
    toolbox: `toolbox-blockly-instance-${tabInfo.id}`,
    trashcan: false,
    collapse: true,
    disable: true,
    oneBasedIndex: true,
    blocklyToolboxDiv: `blocklyToolboxDiv blocklyToolboxDiv-blockly-instance-${tabInfo.id} blocklyToolboxDiv-${(toolboxToggle) ? 'icons' : 'text'}`,
    zoom: {
      controls: false,
      wheel: true,
      startScale: 0.8,
      defaultScale: 0.8,
      maxScale: 3,
      minScale: 0.3,
      scaleSpeed: 1.2,
    },
  };

  const withWorkspace = useRef(tabInfo.withWorkspace || false);
  const agentPortsRef = useRef(tabInfo.agentPorts || []);
  const tabInfoPortRef = useRef(tabInfo.port || '');

  useEffect(() => {
    agentPortsRef.current = bloquesState.agentPorts;
    tabInfoPortRef.current = bloquesState.agentPorts[0]?.Name || '';
    if (demoWorkspace) {
      demoWorkspace.chageBoardVersion();
    }
  }, [bloquesState.agentPorts]);

  useEffect(() => {
    const newData = {};
    newData.agentPorts = tabInfo.agentPorts;
    // TODO: Collab session currently doesn't allow port change. Fix that.
    // newData.port = 'COM3'; //tabInfo.port;
    // tabInfoPortRef.current = newData.port;
    if (JSON.stringify(agentPortsRef.current) !== JSON.stringify(newData.agentPorts)) {
      setBlocklyProject(newData);
    }
    agentPortsRef.current = newData.agentPorts;
    if (demoWorkspace) {
      demoWorkspace.chageBoardVersion();
    }
  }, [tabInfo.agentPorts]);

  useEffect(() => {
    if (!loading && tabInfo.userRole && tabInfo.userRole === 'LEADER' && socket) {
      socket.emit('leaderIsBack', tabInfo.collaborationSession);
    }
  }, [loading]);

  useEffect(() => {
    if (demoWorkspace && document.querySelectorAll(`#blockly-instance-${tabInfo.id} .blocklyWorkspace`).length > 0) {
      afterLoadBlocklyPanel();
    }
    if (setWorkspace) {
      setWorkspace(demoWorkspace);
    }
  }, [demoWorkspace]);

  useEffect(() => {
    dispatch(startLoading());
    const timestamp = pjson.version;
    const scriptsToLoad = [];

    if (boardType === boardTypes.CODE) {
      window.ace.define('ace/snippets/c_cpp', ['require', 'exports', 'module'], (e, t, n) => {
        t.snippetText = "## STL Collections\n# std::array\nsnippet array\n	std::array<${1:T}, ${2:N}> ${3};${4}\n# std::vector\nsnippet vector\n	std::vector<${1:T}> ${2};${3}\n# std::deque\nsnippet deque\n	std::deque<${1:T}> ${2};${3}\n# std::forward_list\nsnippet flist\n	std::forward_list<${1:T}> ${2};${3}\n# std::list\nsnippet list\n	std::list<${1:T}> ${2};${3}\n# std::set\nsnippet set\n	std::set<${1:T}> ${2};${3}\n# std::map\nsnippet map\n	std::map<${1:Key}, ${2:T}> ${3};${4}\n# std::multiset\nsnippet mset\n	std::multiset<${1:T}> ${2};${3}\n# std::multimap\nsnippet mmap\n	std::multimap<${1:Key}, ${2:T}> ${3};${4}\n# std::unordered_set\nsnippet uset\n	std::unordered_set<${1:T}> ${2};${3}\n# std::unordered_map\nsnippet umap\n	std::unordered_map<${1:Key}, ${2:T}> ${3};${4}\n# std::unordered_multiset\nsnippet umset\n	std::unordered_multiset<${1:T}> ${2};${3}\n# std::unordered_multimap\nsnippet ummap\n	std::unordered_multimap<${1:Key}, ${2:T}> ${3};${4}\n# std::stack\nsnippet stack\n	std::stack<${1:T}> ${2};${3}\n# std::queue\nsnippet queue\n	std::queue<${1:T}> ${2};${3}\n# std::priority_queue\nsnippet pqueue\n	std::priority_queue<${1:T}> ${2};${3}\n##\n## Access Modifiers\n# private\nsnippet pri\n	private\n# protected\nsnippet pro\n	protected\n# public\nsnippet pub\n	public\n# friend\nsnippet fr\n	friend\n# mutable\nsnippet mu\n	mutable\n## \n## Class\n# class\nsnippet cl\n	class ${1:`Filename('$1', 'name')`} \n	{\n	public:\n		$1(${2});\n		~$1();\n\n	private:\n		${3:/* data */}\n	};\n# member function implementation\nsnippet mfun\n	${4:void} ${1:`Filename('$1', 'ClassName')`}::${2:memberFunction}(${3}) {\n		${5:/* code */}\n	}\n# namespace\nsnippet ns\n	namespace ${1:`Filename('', 'my')`} {\n		${2}\n	} /* namespace $1 */\n##\n## Input/Output\n# std::cout\nsnippet cout\n	std::cout << ${1} << std::endl;${2}\n# std::cin\nsnippet cin\n	std::cin >> ${1};${2}\n##\n## Iteration\n# for i \nsnippet fori\n	for (int ${2:i} = 0; $2 < ${1:count}; $2${3:++}) {\n		${4:/* code */}\n	}${5}\n\n# foreach\nsnippet fore\n	for (${1:auto} ${2:i} : ${3:container}) {\n		${4:/* code */}\n	}${5}\n# iterator\nsnippet iter\n	for (${1:std::vector}<${2:type}>::${3:const_iterator} ${4:i} = ${5:container}.begin(); $4 != $5.end(); ++$4) {\n		${6}\n	}${7}\n\n# auto iterator\nsnippet itera\n	for (auto ${1:i} = $1.begin(); $1 != $1.end(); ++$1) {\n		${2:std::cout << *$1 << std::endl;}\n	}${3}\n##\n## Lambdas\n# lamda (one line)\nsnippet ld\n	[${1}](${2}){${3:/* code */}}${4}\n# lambda (multi-line)\nsnippet lld\n	[${1}](${2}){\n		${3:/* code */}\n	}${4}\n", t.scope = 'c_cpp';
      });
    }

    if (boardType === boardTypes.SENIOR) {
      scriptsToLoad.push('/js/educablocks/blockly_compressed.js');
      scriptsToLoad.push('/js/educablocks/blocks_compressed.js');
      scriptsToLoad.push('/js/educablocks/arduino_compressed.js');
      scriptsToLoad.push('/js/educablocks/javascript_compressed.js');
      scriptsToLoad.push(`/js/educablocks/msg/js/${themeLang}.js`);
      scriptsToLoad.push('/js/educablocks/zfunctionsBlocks.js');
      scriptsToLoad.push('/js/educablocks/microbit.js');
      scriptsToLoad.push('/js/educablocks/drone.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsArduino.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsJavaScript.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsDrone.js');
      scriptsToLoad.push('/js/educablocks/userMarker.js');
    }
    if (boardType === boardTypes.JUNIOR) {
      scriptsToLoad.push('/js/educablocks/blockly_compressed_horizontal.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsBlocksJR.js');
      scriptsToLoad.push('/js/educablocks/arduino_compressed.js');
      scriptsToLoad.push('/js/educablocks/javascript_compressed.js');
      scriptsToLoad.push(`/js/educablocks/msg/js/${themeLang}.js`);
      scriptsToLoad.push('/js/educablocks/zfunctionsArduinoJR.js');
      scriptsToLoad.push('/js/educablocks/zfunctionsJavaScriptJR.js');
    }
    if (tabInfo.remoteSession) {
      scriptsToLoad.push('https://meet.jit.si/external_api.js');
    }
    if (tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13') {
      scriptsToLoad.push('/js/educablocks/simulator/three.min.js');
      scriptsToLoad.push('/js/educablocks/simulator/Detector.js');
      scriptsToLoad.push('/js/educablocks/simulator/OrbitControls.js');
      scriptsToLoad.push('/js/educablocks/simulator/THREEx.KeyboardState.js');
      scriptsToLoad.push('/js/educablocks/simulator/THREEx.FullScreen.js');
      scriptsToLoad.push('/js/educablocks/simulator/THREEx.WindowResize.js');
      scriptsToLoad.push('/js/educablocks/simulator/objLoader.js');
      scriptsToLoad.push('/js/educablocks/simulator/ImprovedNoise.js');
      scriptsToLoad.push('/js/educablocks/simulator/BufferGeometryUtils.js');
      scriptsToLoad.push('/js/educablocks/simulator/NormalMapShader.js');
      scriptsToLoad.push('/js/educablocks/simulator/ShaderTerrain.js');
      scriptsToLoad.push('/js/educablocks/simulator/stats.min.js');
      scriptsToLoad.push('/js/educablocks/simulator/simulator_api.js');
      scriptsToLoad.push('/js/educablocks/simulator/simulator.js');
    }

    const scriptsToLoadWithTimestamp = scriptsToLoad.map((i) => `${i}?${timestamp}`);

    if (boardType === boardTypes.CODE) {
      loadExt(scriptsToLoadWithTimestamp, afterLoadBlocklyPanel);
    } else if ((tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13') && document.querySelectorAll('script[src*="simulator/simulator"]').length > 0 && document.querySelectorAll('script[src*="blockly_compressed"]').length > 0) {
      initBlockly();
    } else if (tabInfo.board.profile !== 'drone' && tabInfo.board.profile !== 'drone13' && document.querySelectorAll('script[src*="blockly_compressed"]').length > 0) {
      initBlockly();
    } else {
      loadExt(scriptsToLoadWithTimestamp, initBlockly);
    }

    dispatch(setMLActive(tabInfo.board.iaModel !== undefined));

    return () => {
      withWorkspace.current = false;
      setDemoWorkspace(null);
      window.removeEventListener('resize', onWorkspaceResize, false);
      if (demoWorkspace) {
        if (boardType === boardTypes.SENIOR) {
          demoWorkspace.removeChangeListener(window.Blockly.Events.disableOrphans);
        }
        demoWorkspace.removeChangeListener(events.bind(this));
      }
      setDemoWorkspace(null);
      setBlocklyProject({});
    }
  }, []);

  useEffect(() => {
    withWorkspace.current = tabInfo.withWorkspace;
    // console.log('====================tabInfo?.withWorkspace', (tabInfo.withWorkspace !== blocklyProject.withWorkspace));
    if (!tabInfo.withWorkspace) {
      if (boardType === boardTypes.CODE) {
        afterLoadBlocklyPanel();
      } else {
        initBlockly();
      }
    }
    if (!tabInfo.collaborationProject) {
      initBlockly();
    }
  }, [tabInfo?.withWorkspace]);

  const onWorkspaceResize = () => {
    if (demoWorkspace) {
      window.Blockly.svgResize(demoWorkspace);
    }
  };

  function finishLoadingMLPanel() {
    setLoading(false);
  }

  function afterLoadBlocklyPanel() {
    if (isCreabots || !iaModelBin || !iaModelJson) {
      setLoading(false);
    }
    dispatch(finishLoading());
    const list = document.querySelectorAll(`#blockly-instance-${tabInfo.id} .blocklyFlyout .blocklyWorkspace .blocklyZoom .modal-backdrop`);
    if (list.length > 0) {
      for (let i = 0; i < list.length; i += 1) {
        list[i].remove();
      }
    }
    const modals = document.querySelectorAll('.modal-backdrop');
    for (let i = 0; i < modals.length; i += 1) {
      modals[i].remove();
    }
    if (tabInfo.board.type !== boardTypes.CODE) {
      $('div[role="treeitem"][aria-expanded]').attr('aria-expanded', 'false');
      $('div[role="treeitem"][aria-expanded]').css('height', `${getHeightOfRow()}px`);

      updateCodeProject(tabInfo.code || '');
    }

    if (tabInfo.board.type === boardTypes.JUNIOR) {
      const ele = document.querySelector('.blocklyToolboxDiv');
      if (ele) {
        ele.classList.add('darkTheme');
        ele.classList.add('BlocklyPanelFull');
        ele.classList.add('blocklyToolboxDiv-text');
      }
    }

    window.cleanToolBoxSelection = () => {
      $('div[role="treeitem"]').attr('aria-selected', false);
      $('div[role="treeitem"][aria-expanded]').attr('aria-expanded', false);
      $('div[role="treeitem"][aria-expanded]').css('height', `${getHeightOfRow()}px`);
    };

    $(document).on('click change', '.blocklyWorkspace', () => {
      if ($('.blocklyFlyout').css('display') === 'none') {
        window.cleanToolBoxSelection();
      }
    });

    $(window.document).on('click', 'div[role="treeitem"]', function (e) {
      e.stopPropagation();
      e.preventDefault();
      $('div[role="treeitem"]').attr('aria-selected', false);
      $(this).attr('aria-selected', ($(this).attr('aria-selected') === 'false'));
      if ($(this).attr('aria-expanded') === 'true') {
        window.cleanToolBoxSelection();
      } else if (!($(this).parent().parent().attr('role') === 'treeitem')) {
        $('div[role="treeitem"][aria-expanded]').attr('aria-expanded', false);
        $('div[role="treeitem"][aria-expanded]').css('height', `${getHeightOfRow()}px`);
        if ($(this).attr('aria-expanded') !== undefined) $(this).attr('aria-expanded', ($(this).attr('aria-expanded') === 'false'));
        if ($(this).attr('aria-expanded') === 'true') {
          $(this).css('height', `${($($(this).children()[1]).children().length + 1) * getHeightOfRow()}px`);
        }
      }
    });

    const toolboxTrashcan = `
    <div class="toolboxTrashcan">
      <div class="trash-parent">
        <span class="trash">
            <span></span>
            <i></i>
          </span>
      </div>
    <div>`;

    [].forEach.call(window.document.querySelectorAll('.blocklyTreeRoot'), (item) => {
      item.innerHTML += toolboxTrashcan;
    });

    if (boardType === boardTypes.SENIOR && socket && demoWorkspace) {
      if (tabInfo.collaborationProject && tabInfo.collaborationSession) {
        const workspaceClient = new WorkspaceClient(socket, window.Blockly, demoWorkspace, userData.userId, tabInfo.collaborationSession);
        workspaceClient.start().then(() => {
          workspaceClient.setUsersList(teamList);
          demoWorkspace.addChangeListener((event) => {
            // console.log('[EVENT FIRED]', event);
            if (typeof event.type === 'undefined' || event.type === window.Blockly.Events.UI) {
              return;
            }
            workspaceClient.handleUnmarkPosition(event);
            workspaceClient.addEvent(event);
            if (!window.Blockly.Events.getGroup()) {
              workspaceClient.flushEvents();
            }
          });
        });
      }

      window.removeEventListener('resize', onWorkspaceResize, false);
      window.addEventListener('resize', onWorkspaceResize, false);
      onWorkspaceResize();
      demoWorkspace.clearUndo();
    }
  }

  const getHeightOfRow = () => ((window.innerHeight > 680) ? 46 : 35);

  const setCenter = () => {
    const { defaultScale } = blocklyOptions.zoom;
    demoWorkspace.setScale(defaultScale);
    setTimeout(() => { demoWorkspace.scrollCenter(); }, 100);
  };

  const setZoom = (direction) => {
    const currentScale = demoWorkspace.scale;

    const newScale = (direction === 'up') ? currentScale + 0.1 : currentScale - 0.1;

    demoWorkspace.setScale(newScale);
  };

  const setUndo = (direction) => {
    demoWorkspace.undo(direction);
  };

  const changeToolboxToggle = () => {
    setToolboxToggle(!toolboxToggle);
  };

  const toggleDarkTheme = () => {
    setDarkthemeToggle(!darkthemeToggle);
  };

  const initBlockly = () => {
    const blocklyDiv = document.getElementById(`blockly-instance-${tabInfo.id}`);
    if (typeof window.Blockly.inject === 'function' && blocklyDiv) {
      const preWorkspace = withWorkspace.current;
      blocklyDiv.innerHTML = '';
      let newDemoWorkspace = demoWorkspace;

      if (tabInfo.board.type === boardTypes.JUNIOR && tabInfo.board.toolboxLayout === 'horizontal') {
        blocklyOptions.horizontalLayout = true;
        blocklyOptions.toolboxPosition = 'end';
        // blocklyOptions.scrollbars = true;
      }
      if (typeof blocklyOptions.toolbox === 'string') {
        blocklyOptions.toolbox = document.getElementById(blocklyOptions.toolbox);
      }
      newDemoWorkspace = window.Blockly.inject(blocklyDiv || null, blocklyOptions);
      if (tabInfo.board.type === boardTypes.SENIOR && window.Blockly.VariablesJavascriptDynamic) {
        newDemoWorkspace.registerToolboxCategoryCallback('VARIABLE_JAVASCRIPT_DYNAMIC', window.Blockly.VariablesJavascriptDynamic.flyoutCategory);
        newDemoWorkspace.registerToolboxCategoryCallback('PROCEDURE_JAVASCRIPT', window.Blockly.ProceduresJavascriptDynamic.flyoutCategory);
      }
      if (tabInfo.board.type === boardTypes.JUNIOR && tabInfo.board.toolboxLayout === 'horizontal') {
        newDemoWorkspace.scrollbar = new window.Blockly.Scrollbar(newDemoWorkspace, true);
      }

      let xml = createElementFromHTML(ReactDOMServer.renderToString(getProfile(tabInfo.board.profile).initXml)); // BASE
      if (preWorkspace) xml = window.Blockly.Xml.textToDom(preWorkspace);

      // PIN MAPPING FUNCTIONS
      if (boardType === boardTypes.SENIOR) {
        newDemoWorkspace.pinDB_ = {
          /*
          BLOCK_COMPONENT:
          led
          motor
          servo
          lcd
          matrix
          button
          motordc
          buzzer
  
          {
            {PIN_NUMBER}: {
              {BLOCK_COMPONENT}_{PIN_NAME}: [{BLOCK_ID}, ...]
            },
          }
          */
          pins: {},
          pinUsed(pin, component) {
            // Inverse logic, if the same block component we're trying to add exists, it's ok.
            // Otherwise, we aren't allowed to use the same pin with different block components.
            if (this.pins.hasOwnProperty(pin) || component === '') {
              if (this.pins[pin].hasOwnProperty(component)) {
                return false;
              }
              return true;
            }
            return false;
          },
          addPin(pin, component, blockId) {
            if (!this.pins[pin]) {
              this.pins[pin] = {};
              this.pins[pin][component] = [blockId];
            } else if (typeof this.pins[pin][component] !== 'undefined' && this.pins[pin][component].indexOf(blockId) === -1) {
              this.pins[pin][component].push(blockId);
            }
          },
          deletePin(blockId) {
            let deleted = false;
            for (const pin in this.pins) {
              if (this.pins.hasOwnProperty(pin)) {
                for (const component in this.pins[pin]) {
                  if (this.pins[pin].hasOwnProperty(component)) {
                    if (this.pins[pin][component].length > 1) {
                      for (let i = 0; i < this.pins[pin][component].length; i++) {
                        if (this.pins[pin][component][i] === blockId) {
                          this.pins[pin][component].splice(i, 1);
                          deleted = true;
                        }
                      }
                    } else if (this.pins[pin][component][0] === blockId) {
                      delete this.pins[pin];
                      deleted = true;
                    }
                  }
                }
              }
            }
            return deleted;
          },
        };


        newDemoWorkspace.addPinCheckingUsed = function (blockId) {
          if (typeof newDemoWorkspace.getBlockById(blockId).getPins === 'function' && !newDemoWorkspace.getBlockById(blockId).disabled) {
            const pinCombos = newDemoWorkspace.getBlockById(blockId).getPins();
            let pinValue = '';
            let pinType = '';
            let nextOption = [];
            let singlePin = [];
            let occupied = false;
            let j = 0;
            for (const i in pinCombos) {
              // Inter-pin check. If a dropdown pin on the same Block is used, select the next one available.
              pinValue = newDemoWorkspace.getBlockById(blockId).getFieldValue(pinCombos[i]);
              pinType = `${newDemoWorkspace.getBlockById(blockId).component}_${pinCombos[i]}`;
              singlePin = pinValue.split(',');
              for (const p in singlePin) {
                if (newDemoWorkspace.pinDB_.pinUsed(singlePin[p], pinType)) {
                  occupied = true;
                }
              }
              j = 0;
              while (occupied) {
                if (typeof newDemoWorkspace.getBlockById(blockId).getField(pinCombos[i]).getOptions()[j] !== 'undefined') {
                  nextOption = newDemoWorkspace.getBlockById(blockId).getField(pinCombos[i]).getOptions()[j];
                  newDemoWorkspace.getBlockById(blockId).getField(pinCombos[i]).setValue(nextOption[1]);
                  pinValue = newDemoWorkspace.getBlockById(blockId).getFieldValue(pinCombos[i]);
                  pinType = `${newDemoWorkspace.getBlockById(blockId).component}_${pinCombos[i]}`;
                  singlePin = pinValue.split(',');

                  occupied = false;
                  for (const p in singlePin) {
                    if (newDemoWorkspace.pinDB_.pinUsed(singlePin[p], pinType)) {
                      occupied = true;
                    }
                  }
                  j += 1;
                } else {
                  occupied = false;
                }
              }


              if (singlePin.length > 0) {
                for (const p in singlePin) {
                  newDemoWorkspace.pinDB_.addPin(
                    singlePin[p],
                    `${newDemoWorkspace.getBlockById(blockId).component}_${pinCombos[i]}`,
                    blockId,
                  );
                }
              }
            }
          }
        };

        newDemoWorkspace.listenToPinEvents = function (event) {
          /// CREATE EVENT ////////////////////////////////
          if (event.type === Blockly.Events.BLOCK_CREATE) {
            let blockIds = [];
            blockIds.push(event.blockId);
            if (typeof event.ids !== 'undefined') {
              blockIds = event.ids;
            }
            let blockId;
            for (const i in blockIds) {
              blockId = blockIds[i];
              newDemoWorkspace.addPinCheckingUsed(blockId);
            }
            newDemoWorkspace.markFocused();
          }

          /// CHANGE EVENT ////////////////////////////////
          if (event.type === Blockly.Events.BLOCK_CHANGE
            && typeof newDemoWorkspace.getBlockById(event.blockId).getPins === 'function') {
            newDemoWorkspace.pinDB_.deletePin(event.blockId);
            newDemoWorkspace.addPinCheckingUsed(event.blockId);
            newDemoWorkspace.markFocused();
          }

          /// DELETE EVENT ////////////////////////////////
          if (event.type === Blockly.Events.BLOCK_DELETE) {
            let deleted = false;
            for (let i = 0; i < event.ids.length; i++) {
              deleted = newDemoWorkspace.pinDB_.deletePin(event.ids[i]);
            }
            if (deleted) {
              newDemoWorkspace.markFocused();
            }
          }
        };
        newDemoWorkspace.addChangeListener(newDemoWorkspace.listenToPinEvents);

        newDemoWorkspace.getHardwarePinsCombo = function (pinType, blockComponent = '') {
          let pins = [];
          if (pinType !== '') {
            pins = tabInfo.board.pins[pinType] || [[intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' }), `${intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' })},,`]];
          }

          const newPins = [];
          let singlePin = [];
          let occupied = false;
          for (let i = 0; i < pins.length; i++) {
            singlePin = pins[i][1].split(',');
            occupied = false;
            for (const j in singlePin) {
              if (blockComponent !== '' && newDemoWorkspace.pinDB_.pinUsed(singlePin[j], blockComponent)) {
                occupied = true;
              }
            }
            if (!occupied) {
              newPins.push(pins[i]);
            }
          }
          // It can't be an empty array
          if (newPins.length <= 0) {
            newPins.push([intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' }), `${intl.formatMessage({ id: 'blocks.blockly.pinNotAvailable' })},,`]);
          }
          return newPins;
        };
      }

      if (boardType === boardTypes.SENIOR || boardType === boardTypes.JUNIOR) {
        newDemoWorkspace.chageBoardVersion = function (fireChangeEvent = true) {
          const agentPorts = agentPortsRef.current;
          const blocks = newDemoWorkspace.getAllBlocks();
          for (let i = 0; i < blocks.length; i += 1) {
            if (typeof blocks[i].setBoardVersion === "function" && !blocks[i].disabled) {
              let boardVersion = '';
              for (let i = 0; i < agentPorts.length; i += 1) {
                if (agentPorts[i].Name === tabInfoPortRef.current) {
                  boardVersion = `${agentPorts[i].VendorID}-${agentPorts[i].ProductID}`;
                }
              }
              // console.log('=========CHANGE BOARD VERSION', fireChangeEvent, boardVersion, tabInfoPortRef.current, agentPorts);
              blocks[i].setBoardVersion(boardVersion.toUpperCase());
              if (fireChangeEvent) {
                setTimeout(() => {
                  this.fireChangeListener('resize');
                  window.Blockly.svgResize(this);
                }, 200);
              }
            }
          }
        }

        newDemoWorkspace.addChangeListener(() => ((dw) => {
          dw.chageBoardVersion(false);
        })(newDemoWorkspace));
      }

      newDemoWorkspace.setMLClasses = function (classNames = {}) {
        newDemoWorkspace.ML = {
          classNames
        };

        const blocks = newDemoWorkspace.getAllBlocks();
        for (let i = 0; i < blocks.length; i += 1) {
          if (typeof blocks[i].updateClassNames === 'function') {
            blocks[i].updateClassNames();
          }
        }
        // newDemoWorkspace.fireChangeListener('resize');
        window.Blockly.svgResize(newDemoWorkspace);
      };

      newDemoWorkspace.getMLClasses = function () {
        const classes = [];
        if (newDemoWorkspace.ML) {
          Object.keys(newDemoWorkspace.ML.classNames).forEach((key) => {
            classes.push([newDemoWorkspace.ML.classNames[key], key]);
          });
        }
        return classes;
      };

      window.Blockly.Xml.domToWorkspace(xml, newDemoWorkspace);

      $(window).resize(function (dw) {
        return function () {
          setTimeout(() => {
            dw.fireChangeListener('resize');
            window.Blockly.svgResize(dw);
          }, 200);
        };
      }(newDemoWorkspace));

      //  DISABLE OPRHANS
      if (boardType === boardTypes.SENIOR) {
        newDemoWorkspace.addChangeListener(window.Blockly.Events.disableOrphans);
      }

      //  EVENT LISTENER
      newDemoWorkspace.addChangeListener(events.bind(this));

      if (boardType === boardTypes.JUNIOR) {
        newDemoWorkspace.setScale(1.8);
        newDemoWorkspace.getVariableMap = function () { return false; };
        window.Blockly.Variables.allDeveloperVariables = function () { return false; };
        window.Blockly.utils.wrap = function () { return false; };
        window.Blockly.Variables.allUsedVarModels = function () { return false; };
        window.Blockly.JavaScript.variableDB_ = {};
        window.Blockly.JavaScript.variableDB_.setVariableMap = function () { return false; };
        window.Blockly.JavaScript.variableDB_.reset = function () { return false; };
        window.Blockly.JavaScript.variableDB_.getVariableMap = function () { return false; };
      }

      //  CODE SAVE
      newDemoWorkspace.addChangeListener(() => ((demo) => {
        updateBlocklyProject(demo);
      })(newDemoWorkspace));

      updateBlocklyCss();

      setDemoWorkspace(newDemoWorkspace);
    }
  };

  const updateBlocklyCss = () => {
    const cssBlockly = window.Blockly.Css.CONTENT.join('');
    const newData = {};
    newData.canvasCss = `<defs><style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${cssBlockly}]]></style></defs>`;
    newData.blocksCss = `<defs><style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${cssContent}]]></style></defs>`;
    setBlocklyProject(newData);
  };

  const updateBlocklyProject = (newDemoWorkspace) => {
    const lang = tabInfo.board.lang || 'Arduino';
    const newCode = (window.Blockly[lang]) ? window.Blockly[lang].workspaceToCode(newDemoWorkspace) : '';
    setCodeGenerated(newCode);

    if (boardType !== boardTypes.CODE && newDemoWorkspace) {
      let canvas = newDemoWorkspace.svgBlockCanvas_.cloneNode(true);
      canvas.removeAttribute('transform');
      canvas = new XMLSerializer().serializeToString(canvas);

      const canvasBBox = document.getElementsByClassName('blocklyBlockCanvas')[0]?.getBBox();

      const newData = {};
      newData.withWorkspace = new XMLSerializer().serializeToString(window.Blockly.Xml.workspaceToDom(newDemoWorkspace));
      newData.canvas = canvas;
      newData.canvasBBoxX = canvasBBox?.x || 0;
      newData.canvasBBoxY = canvasBBox?.y || 0;
      newData.canvasBBoxWidth = canvasBBox?.width || 0;
      newData.canvasBBoxHeight = canvasBBox?.height || 0;
      newData.canvasCode = newCode;
      newData.port = tabInfo.port || '';
      newData.code = newCode;
      newData.agentPorts = agentPortsRef.current || [];
      setBlocklyProject(newData);
    }
  };

  const updateCodeProject = (newCode) => {
    const newData = {};
    newData.code = newCode;
    setBlocklyProject(newData);
  };

  const onPortChange = (newPort) => {
    const newData = {};
    newData.port = newPort;
    setBlocklyProject(newData);
  };

  const getProfile = (param) => profiles.default[param];

  const codeToggleAction = () => {
    setCodeToggle(!codeToggle);
    setTimeout(() => {
      window.Blockly.svgResize(demoWorkspace);
    }, 100);
  };

  const mlPanelToggleAction = () => {
    setTimeout(() => {
      window.Blockly.svgResize(demoWorkspace);
    }, 100);
  };

  const launchDroneSimulation = () => {
    const mission = eval(codeGenerated);
    const commands = mission.split('|');
    let land = false;
    for (let i = 0; i < commands.length; i += 1) {
      commands[i] = commands[i].replace(/!/, '?');
      if (commands[i] === 'land') {
        land = true;
      }
    }
    if (!land) {
      commands.push('land');
    }

    window.commands = commands;
    console.log('CODE:', commands, codeGenerated);
  };

  const resetDroneSimulation = () => {
    window.commands = ['reset'];
  };

  const fullScreenDroneSimulation = () => {
    const elem = document.getElementById(`droneArea-blockly-instance-${tabInfo.id}`);
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  };

  const toggleGridDroneSimulation = () => {
    const ele = document.querySelector('#toggleGrid-icon');
    if (window.toggle === undefined || window.toggle === true) {
      window.toggle = false;
      ele.classList.remove('icon-view-show');
      ele.classList.add('icon-view-hide');
    } else {
      window.toggle = true;
      ele.classList.remove('icon-view-hide');
      ele.classList.add('icon-view-show');
    }
  };

  const shootMsg = (msg) => {
    let ele = document.querySelector(`.blocklyPanel-blockly-instance-${tabInfo.id} .shootMsg`);
    if (!ele) {
      ele = document.querySelector(`.codePanel-blockly-instance-${tabInfo.id} .shootMsg`);
    }
    if (ele) {
      if (window.oldMessage !== msg) {
        ele.classList.remove('show');
        setTimeout(() => {
          window.oldMessage = msg;
          ele.innerHTML = msg;
          ele.classList.add('show');
        }, 200);
      }
    }
  };

  const buildBlockly = (params) => {
    if (buildingFunction) {
      buildingFunction(params);
    }
  };

  return (
    <div className={`${(darkthemeToggle) ? 'darkTheme' : ''} BlocklyPanelFull`}>
      {(boardType !== boardTypes.CODE && tabInfo.active) && (
        <ToolsPanel
          onSetCenter={setCenter}
          onSetUndo={setUndo}
          onSetZoom={setZoom}
          onChangeToolboxToggle={changeToolboxToggle}
          onToggleDarkTheme={toggleDarkTheme}
          toolboxToggle={toolboxToggle}
          darkthemeToggle={darkthemeToggle}
          isCreabots={isCreabots}
        />
      )}
      <div id="BlocklyPanel-Container" className={`BlocklyPanel ${(boardType === boardTypes.JUNIOR) ? 'BlocklyJRPanel' : ''} ${(tabInfo.active) ? 'active' : ''} ${tabInfo.board.class}-panel`}>
        <div className="container-fluid">
          <div className={`p-relative row overflow-hidden ${(boardType === boardTypes.CODE) ? 'codePanel' : 'blocklyPanel'}-blockly-instance-${tabInfo.id}`}>
            <>
              {(boardType === boardTypes.CODE) ? (
                <div className="content-codeBox-blockly">
                  <AceEditor
                    mode="c_cpp"
                    theme={darkthemeToggle ? 'dracula' : 'chrome'}
                    value={blocklyProject.code}
                    name={`aceEditor-blockly-instance-${tabInfo.id}`}
                    onChange={updateCodeProject}
                    width={window.innerWidth}
                    height={window.innerHeight - 130}
                    fontSize={16}
                    readOnly={false}
                    showPrintMargin={true}
                    showGutter={true}
                    highlightActiveLine={true}
                    editorProps={{
                      $blockScrolling: Infinity,
                    }}
                    setOptions={{
                      enableBasicAutocompletion: true,
                      enableLiveAutocompletion: true,
                      enableSnippets: true,
                      showPrintMargin: false,
                      showLineNumbers: true,
                    }}
                  />
                </div>
              ) : (
                <div id="blocklyPanel-Right" className={`col-12 p-0 blocklyPanel ${(tabInfo.collaborationProject && tabInfo.collaborationSession) ? 'blocklyPanel-collab' : ''}`}>
                  <div className="blocklyDiv" id={`blockly-instance-${tabInfo.id}`} />
                  <xml id={blocklyOptions.toolbox}>
                    {getProfile(tabInfo.board.profile).categoryXml}
                  </xml>
                  <div className="blocklyWidgetDiv" />
                  <div className="blocklyDropDownDiv">
                    <div className="blocklyDropDownContent" />
                    <div className="blocklyDropDownArrow" />
                  </div>
                  <div className="blocklyToolxmltipDiv" />
                </div>
              )}
              {(boardType !== boardTypes.CODE && !noCodePanel) ? (
                <CodePanel
                  darktheme={darkthemeToggle}
                  active={codeToggle}
                  content={codeGenerated}
                  onChange={codeToggleAction}
                  id={`blockly-instance-${tabInfo.id}`}
                />
              ) : ('')}

              {!isCreabots ? (
                <MLPanel
                  onChange={mlPanelToggleAction}
                  workspace={demoWorkspace}
                  iaModel={tabInfo.board.iaModel || null}
                  iaModelJson={iaModelJson}
                  onFinishLoading={finishLoadingMLPanel}
                  iaModelBin={iaModelBin}
                  board={tabInfo.board || {}}
                  darktheme={darkthemeToggle}
                  isCreabots={isCreabots}
                  isFreeProject={isFreeProject}
                />
              ) : ('')}

              {(tabInfo.active && (tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13')) ? (
                <div className={`col-12 p-0 droneSimulationBox ${(droneSimulationToggle) ? 'droneSimulationBox-active' : ''}`}>
                  <div className="content-droneSimulationBox">
                    {/* <!-- Map preview modal --> */}
                    <div className="modal" id="mapPreviewModal" style={{ width: '100% !important', height: '100% !important' }} />
                    <div className={`droneArea ${(droneSimulationToggle) ? 'visible' : 'hidden'}`} id={`droneArea-blockly-instance-${tabInfo.id}`}>
                      {/* <div className={`droneArea ${(droneSimulationToggle) ? 'visible' : 'hidden'}`} id="droneArea"> */}
                      <div id="toast-container" />
                      <div className="button-container">
                        <Tooltip disableFocusListener title="Comenzar simulación">
                          <button type="button" onClick={launchDroneSimulation} className="btn green" data-position="top" id="previewMission">
                            <span className="icon-media-play" />
                          </button>
                        </Tooltip>
                        <Tooltip disableFocusListener title="Resetear simulación">
                          <button type="button" onClick={resetDroneSimulation} className="btn green" data-position="top" id="resetSimulator">
                            <span className="icon-cancel" />
                          </button>
                        </Tooltip>
                        <Tooltip disableFocusListener title="Pantalla completa">
                          <button type="button" onClick={fullScreenDroneSimulation} className="btn green" data-position="top" id="fullScreen">
                            <span className="icon-fullscreen" />
                          </button>
                        </Tooltip>
                        <Tooltip disableFocusListener title="Mostrar/Ocultar grilla">
                          <button type="button" onClick={toggleGridDroneSimulation} className="btn green" data-position="top" id="toggleGrid">
                            <span className="icon-view-hide" id="toggleGrid-icon" />
                          </button>
                        </Tooltip>
                        {/* <button type="button" className="btn green" data-position="top" id="ringGen">
                              <i className="material-icons">panorama_fish_eye</i>
                            </button> */}
                        <Tooltip disableFocusListener title="Activar/Desactivar sonido">
                          <button type="button" className="btn green" data-position="top" id={`toogleSound-droneArea-blockly-instance-${tabInfo.id}`}>
                            <span className="icon-mic" id={`toogleSound-icon-droneArea-blockly-instance-${tabInfo.id}`} />
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  <div className="toggle-droneSimulationBox" style={(tabInfo.remoteSession) ? { top: '135px' } : { top: '75px' }} onKeyPress="" role="button" tabIndex="0" onClick={this.droneSimulationToggleAction}>
                    <span className="droneSimulation-icon" />
                    <span className={`icon-chevron-left ${(droneSimulationToggle) ? 'rotate-arrow' : ''}`} />
                  </div>
                </div>
              ) : ('')}
              {(tabInfo.active && buildAllowed) ? (
                (tabInfo.board.profile === 'drone' || tabInfo.board.profile === 'drone13') ? (
                  <BottomNavDrone
                    shootMsg={shootMsg}
                    drone={drone}
                    bloquesReducer={bloques}
                    id={`blockly-instance-${tabInfo.id}`}
                    actualWidth={actualWidth}
                    buildingFunction={buildBlockly}
                    toolboxToggle={toolboxToggle}
                  />
                ) : (
                  <FooterPanel
                    id={`blockly-instance-${tabInfo.id}`}
                    socketAgent={socketAgent}
                    socketAgentType={socketAgentType}
                    board={tabInfo.board}
                    port={tabInfo.port}
                    boardType={boardType}
                    toolboxToggle={toolboxToggle}
                    horizontalLayout={(tabInfo.board.toolboxLayout === 'horizontal')}
                    buildingFunction={buildBlockly}
                    selectPortChange={onPortChange}
                    portChangeAllowed={portChangeAllowed}
                  />
                )
              ) : ('')}
            </>
          </div>
        </div>
        <div className={`${(loading) ? 'show' : 'fade'} loaderOverAll `}>
          <div className="anibot-large-white" />
        </div>
      </div>
    </div>
  );
}

export default BlocklyComponent;
